<template>
  <section class="content-panel">
    <div class="section-head">
      <div>
        <h2>设备用户</h2>
        <p>按客户查看用户主键与设备标识，可用主键 ID 或设备 ID 检索</p>
      </div>
      <div class="head-actions">
        <CustomerRemoteSelect
          :model-value="admin.selectedCustomerId.value"
          :token="admin.token.value"
          placeholder="选择客户"
          width="200px"
          @change="onCustomerChange"
          @select="onCustomerSelect"
        />
        <el-input
          v-model="keyword"
          clearable
          placeholder="用户ID / 设备ID"
          style="width: 200px"
          @keyup.enter="search"
        />
        <el-button type="primary" @click="search">查询</el-button>
      </div>
    </div>

    <el-table :data="admin.devices.value" stripe>
      <el-table-column prop="id" label="用户ID" width="100" />
      <el-table-column prop="deviceId" label="设备标识" min-width="220" show-overflow-tooltip />
      <el-table-column label="风险状态" width="120">
        <template #default="{ row }">
          <el-tag :type="riskType(row.riskStatus)" effect="light">{{ riskLabel(row.riskStatus) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="lastLoginAt" label="最近登录" min-width="180">
        <template #default="{ row }">{{ row.lastLoginAt || '-' }}</template>
      </el-table-column>
      <el-table-column prop="ipAddress" label="最近IP" min-width="140">
        <template #default="{ row }">{{ row.ipAddress || '-' }}</template>
      </el-table-column>
      <template #empty>
        <el-empty :description="admin.selectedCustomerId.value ? '该客户暂无设备用户' : '请先选择客户'" />
      </template>
    </el-table>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import CustomerRemoteSelect from '@/components/CustomerRemoteSelect.vue'

const props = defineProps({ admin: Object })
const keyword = ref('')

const riskLabel = (status) => ({
  UNKNOWN: '未知',
  SAFE: '安全',
  PASS: '通过',
  RISK: '风险',
  BLOCKED: '已拦截',
  REJECT: '拒绝'
}[status] || (status ? String(status) : '未知'))

const riskType = (status) => ({
  SAFE: 'success',
  PASS: 'success',
  RISK: 'danger',
  BLOCKED: 'danger',
  REJECT: 'danger'
}[status] || 'info')

function onCustomerSelect(item) {
  if (item) props.admin.rememberCustomers([item])
}

function onCustomerChange(id) {
  keyword.value = ''
  props.admin.selectCustomer(id || null)
}

function search() {
  props.admin.loadDevices(keyword.value)
}
</script>

<style scoped>
.head-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
</style>
